import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalBox from "../../ui/ModalBox";
import FormAttendance from "./FormAttendance";

const AddAttendance = () => {
  //state which check open or close modal
  const [open, setOpen] = useState(false);
  //var to navigate another page

  const navigate = useNavigate();
  //close modal function
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  //open modal function when  clicked button

  const handleSuccess = () => {
    setOpen(true);
  };

  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New Attendance
      </Typography>
      <FormAttendance handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Attendance"
        name="Attendance"
      />
    </>
  );
};

export default React.memo(AddAttendance);
